import { render, staticRenderFns } from "./StSocialButtonGroup.vue?vue&type=template&id=3ccfdb94&"
import script from "./StSocialButtonGroup.vue?vue&type=script&lang=js&"
export * from "./StSocialButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./StSocialButtonGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports